import React from 'react';
import { useLoader } from 'src/common/context/loader.context';
import { Loader } from './loader.other';

export const GlobalLoader: React.FC = () => {
  const { isLoading } = useLoader();

  return <Loader overlay={true} loading={isLoading} />;
}; 